import {
  SET_CRITERIAS,
  SET_SELECTED_CRITERIA,
  SET_PER_PAGE,
  SET_SEARCH,
} from './types'

const initialState = {
  list: [],
  pagination: null,
  selected: null,
  per_page: 25,
  search: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CRITERIAS:
      return {
        ...state,
        list: action.payload.criterias || [],
        pagination: action.payload.pagination || initialState.pagination,
      }
    case SET_SELECTED_CRITERIA:
      return {
        ...state,
        selected: action.payload,
      }
    case SET_PER_PAGE:
      return {
        ...state,
        per_page: action.payload,
      }
    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      }
    default:
      return state
  }
}

export default reducer
